// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPlanDetailDto } from './IPlanDetailDto';
import {
    IPlanDetailDtoFromJSON,
    IPlanDetailDtoFromJSONTyped,
    IPlanDetailDtoToJSON,
    IPlanDetailDtoToJSONTyped,
} from './IPlanDetailDto';

/**
 * 
 * @export
 * @interface IOrgBalanceDetailResponse
 */
export interface IOrgBalanceDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    org_id: number;
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceDetailResponse
     */
    org_name: string;
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceDetailResponse
     */
    org_type: IOrgBalanceDetailResponseOrgTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IOrgBalanceDetailResponse
     */
    status: IOrgBalanceDetailResponseStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IOrgBalanceDetailResponse
     */
    is_locked: boolean;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    hsa_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    notional_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    calculated_prefund?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    prefund_holding?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    replenishment_to_be_invoiced?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    replenishment_not_received?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    employee_contributions_total_received?: number;
    /**
     * 
     * @type {number}
     * @memberof IOrgBalanceDetailResponse
     */
    employee_contributions_not_received_yet?: number;
    /**
     * 
     * @type {Date}
     * @memberof IOrgBalanceDetailResponse
     */
    last_updated_at?: Date;
    /**
     * 
     * @type {Array<IPlanDetailDto>}
     * @memberof IOrgBalanceDetailResponse
     */
    plans?: Array<IPlanDetailDto> | null;
}

/**
* @export
* @enum {string}
*/
export enum IOrgBalanceDetailResponseOrgTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}
/**
* @export
* @enum {string}
*/
export enum IOrgBalanceDetailResponseStatusEnum {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    TERMINATED = 'TERMINATED',
    ACTIVATION_FAILED = 'ACTIVATION_FAILED',
    PENDING_TERMINATION = 'PENDING_TERMINATION',
    EXPRESS_SETUP = 'EXPRESS_SETUP',
    ABANDONED = 'ABANDONED',
    TERMINATION_IN_PROGRESS = 'TERMINATION_IN_PROGRESS',
    PENDING_REACTIVATION = 'PENDING_REACTIVATION'
}


/**
 * Check if a given object implements the IOrgBalanceDetailResponse interface.
 */
export function instanceOfIOrgBalanceDetailResponse(value: object): value is IOrgBalanceDetailResponse {
    if (!('org_id' in value) || value['org_id'] === undefined) return false;
    if (!('org_name' in value) || value['org_name'] === undefined) return false;
    if (!('org_type' in value) || value['org_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('is_locked' in value) || value['is_locked'] === undefined) return false;
    return true;
}

export function IOrgBalanceDetailResponseFromJSON(json: any): IOrgBalanceDetailResponse {
    return IOrgBalanceDetailResponseFromJSONTyped(json, false);
}

export function IOrgBalanceDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrgBalanceDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'org_id': json['org_id'],
        'org_name': json['org_name'],
        'org_type': json['org_type'],
        'status': json['status'],
        'is_locked': json['is_locked'],
        'hsa_balance': json['hsa_balance'] == null ? undefined : json['hsa_balance'],
        'notional_balance': json['notional_balance'] == null ? undefined : json['notional_balance'],
        'calculated_prefund': json['calculated_prefund'] == null ? undefined : json['calculated_prefund'],
        'prefund_holding': json['prefund_holding'] == null ? undefined : json['prefund_holding'],
        'replenishment_to_be_invoiced': json['replenishment_to_be_invoiced'] == null ? undefined : json['replenishment_to_be_invoiced'],
        'replenishment_not_received': json['replenishment_not_received'] == null ? undefined : json['replenishment_not_received'],
        'employee_contributions_total_received': json['employee_contributions_total_received'] == null ? undefined : json['employee_contributions_total_received'],
        'employee_contributions_not_received_yet': json['employee_contributions_not_received_yet'] == null ? undefined : json['employee_contributions_not_received_yet'],
        'last_updated_at': json['last_updated_at'] == null ? undefined : (new Date(json['last_updated_at'])),
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(IPlanDetailDtoFromJSON)),
    };
}

export function IOrgBalanceDetailResponseToJSON(json: any): IOrgBalanceDetailResponse {
    return IOrgBalanceDetailResponseToJSONTyped(json, false);
}

export function IOrgBalanceDetailResponseToJSONTyped(value?: IOrgBalanceDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_id': value['org_id'],
        'org_name': value['org_name'],
        'org_type': value['org_type'],
        'status': value['status'],
        'is_locked': value['is_locked'],
        'hsa_balance': value['hsa_balance'],
        'notional_balance': value['notional_balance'],
        'calculated_prefund': value['calculated_prefund'],
        'prefund_holding': value['prefund_holding'],
        'replenishment_to_be_invoiced': value['replenishment_to_be_invoiced'],
        'replenishment_not_received': value['replenishment_not_received'],
        'employee_contributions_total_received': value['employee_contributions_total_received'],
        'employee_contributions_not_received_yet': value['employee_contributions_not_received_yet'],
        'last_updated_at': value['last_updated_at'] == null ? undefined : ((value['last_updated_at']).toISOString()),
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(IPlanDetailDtoToJSON)),
    };
}

